export default __webpack_public_path__ + "static/nocorner-741a11851f8bda6eb7aae363738205a8.png";